import { jsxs as _jsxs } from "react/jsx-runtime";
export function CoordinateMarker({ prefix, num, suffix, joiner = '—', className = '', }) {
    return (_jsxs("span", { "aria-hidden": true, className: `
        font-mono text-[9px] font-normal uppercase
        tracking-[0.12em] text-cyan-text-faint
        ${className}
      `, children: [prefix, joiner, num, suffix ? ` · ${suffix}` : ''] }));
}
//# sourceMappingURL=CoordinateMarker.js.map